export class MessageProcessorBase {
    decode(fieldset) {
        throw new Error('Not implemented');
    }
}
